var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lang-en"},[_c('the-text-view',{attrs:{"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }